<template>
  <div class="animated fadeIn" @keyup.enter="onFilter">
    <div class="form-group row">
      <div class="col-md-12">
        <label> Data:</label>
        <div class="input-group mb-3">
          <b-form-input type="date"
                          id="txtData"
                          name="txtData"
                          v-model="form.data.value"
                          :required="form.data.required"
                          :state="form.data.state"/>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-12 pt-2">
        <button type="button" class="btn btn-third w-100" v-on:click="onFilter">Filtrar</button>
      </div>
      <div class="col-md-12 pt-2">
        <button type="button" class="btn btn-default w-100" v-on:click="onClearFilters">Limpar Filtros</button>
      </div>
    </div>
    <div class="form-group row" style="margin-top: 250px;">&nbsp;<!--Space to scroll--></div>
  </div>
</template>
<script>

import EventTypeSearch from './search.js'
export default EventTypeSearch

</script>



// WEBPACK FOOTER //
// src/views/private/configurations/visitas/kmValue/components/search/search.vue